// invoice.service.ts
import { Injectable } from '@angular/core'
import pdfMake from 'pdfmake/build/pdfmake'
import 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { WorkOrderModel } from './models/workOrder.model'
import { MasterCommonServices } from '../quotation/master.common.service'
import { DatePipe } from '@angular/common'

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  generateInvoice(data: WorkOrderModel, masterCommonService: MasterCommonServices, datePipe: DatePipe): void {
    const logoBase64: string =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARsAAACyCAMAAABFl5uBAAABCFBMVEX///8AAeUAAOUAAOQBYwAAWQAAXAD8/fz0+fT8/P+0yrSSsZKiovP19f4AYADq6v0mJueurvfh4fzV1ftNTuyBgfEvMetBQunw8P35+f8NDeaFhvK/wPe4ufczNOlSU+qbm/N8fPClpfPKyvvNzfhra+9aWuuWlvU9Pel2dvDc3PpmZu7Y5tg9hTwdHudwcO2OjvR5pXno8ugAagDe6t45Ouqty628vPiYmPRfX+1HR+kWbhUkeSOexZ54qXhtpmyOuY1VlFQpdSnF28U4hjhcmltOk03A2sCFtIRjnWLK2sqdvJ00iDKbw5uOtY4aaRp1nnVGgEZbj1sucy1RiVEhfCBsmmxYiVjVMrYIAAASYUlEQVR4nO2d+WOayhbHcSYavU8EwQVxwX3BXKRJjNG0TZfbNm1f09vX+/r+///kzZkZEFTUNIlowveHNiLCzIdZzpk5MwhCpEiRIkWKFGk7JU9OkmGnYU91+vWfP79GcFYpeXuVyBzdHoedjj1U8utV5ugoc/VHBGdRx+/fETQEzp+nYSdl73T6lqI5Okpch52UfVPyK0dDSs77sBOzZzp9OWfzV9iJ2S8dX8SPXMU/hZ2cvVLyz8ycTVRwfDr1FBtScJ65AXgMcj989bFJvFp92vNQ8uLDxw+vL86TrIQcf8542WTesqPJ0y+31x8/Xp+EmdRd6/hTPJHJJOKJl6/P6ef/+tm8hIPJT2/P4nBe/Ow5lZzj1wlOIX4DJef47MgvgHHyMpF5hh1X0mFzlHhN2SQW2IDf8MU1eeIXYSd4hzq+8bNJxhfYQAvjYfOcGpy5qbeGzYnLJvOc2hvhZIty47LJ/Dvs5O5UrvvE25sFNEfQe7l1KnETdnJ3qqTT4GQ+s34q42dD22LnYPw87OTuVl+c+vKRsvlrgQ09xWltXj6r5oZUKu5cZl5SNh/8tt8VnPKFF634qw3Xempye6ozqD7Hb3wGDnXE/Wc8Kzm9EGtM/vD7mtD4Jm8Zr8T1s/PKk9z1jtN5hYUxChgVPWX+Z+bsmbXEoNMX4C5l4t+ATfJDPOMqQe2Zc9oiZY6e5ejx6c3V9+/fXzJ/IPnmw/X19WfQ9Td25Ba+fvcs0YCSybXd8+nps2tqIkWK9FtK7V5hZ3krSa1qNr1zVQ4Ajtkc1RDCO9cg7IxvVnaIMEIotmMhVA475xtlW3jnXCgb/TLsrG9SefclhrPpV8LO+walY2GhQcNS2JlfL7MWWrGRs2FnfoM6oaFBw7DzvkFqWMUGoZoUduY3qKyHhAZbZth536RpGMWG2FJovO+lRtByaCHNq7SUsYWDq84LuhaVLu+/1SeYReTNji6vkOXnwM/xmIsIs/N037XQqmuBCn2jvPeFhkj1sCHlPN/MLuty6IWDu/SctOX5ocXOq3mvZTVWXQs0UcLO9XbysbGC7I0p9rApU4NNlOc/xAV6lpSbn4ZivV1l4dHkZYM7QQ9U9bLJi3BIW2ajeNlYe27ybiEfm7IWcFbprmwQKuwqB4+nR2ITi9hE5SZi88BsZElZIekAxoddPVp7oxsrlDsIm8/RY7FZ7TLgzsGysQNtkruzWaVDGDv3yG8XF4Lk9RnuwUavh5nXu0r1+5qBehA2OKeGmtk7ysdmCc6qwYffZ4OQHWpe7yo/m23022wQmh5SS7xDNqTw5dqhZvXO2hUbgqbbCjWnd9ejsVkwbFCxfCAjWnM9Fhuk9+cqGiP70AqN8GhsiD/VqsylBhnce60t7Zu7l5sn5oevMf3uavs9vTGKYbWyWpNo/KYsBpyVithE434+RWyC5R+/CapTgmeC12FTw2vZjHeUgUeUhw3C6cDT0BIbsbuejbGb9D+mvGxQcIhZES+yKdlr2eDDGo5YKQ8bPAv2k9PzSsXZCKbn0Ao2B+c9LWvOBiE7eIJEREtsPJEBy2xwfyepf1y5bND6YF/bLSUOm9TE5bXEBuEDdC2XNGejrw0K0foOHIeNII0cOItsEO48esJ3IIcNQqP1LUSrwEm4bAQz5xzys0F4dpB+96IYG+JMDjdMAaSqY1Zy5myEdo55oX42CB3WdEKgKBuE9fzGgNbUpIuAjoeNoHZ0TOh42ZBrjZ4GGsIGY4yG2W0qgWkXYYmVh42gpLtwiLOZwbW66cOaTQiW2e1Pe9Uto6DFdrNhFHpezyKlZsvdMTOClc54amf3PqJ6a4lq2wz0olZIUlvKghmkmW1WiUrkWk+iEY4UKVKkSJEiRYoUKVKkSJEi/ba0KmxDpAbPokjZehNGhFvNdPoht4FgN17Qith/OC2kXUtaOkQcjgKHT8Q6wigv0Q1dHnQeX+ni5UimFcmYkdNGD3jf7aWVWQoDR2qVHEa41qZ7LNxnHr8kqf4lzMp0Ozbk/iicHaRUulob+cZyfSKPN4b76n3ZaHUjV8h6ay65MBOdYeB/Pyab84vbF3///eLbtltzipcY1h7EUCxokilVjWFUF+/LRhqR4pf2stHqowGog0kCZgOmFU/ogdicvP7xDvZzPbr6+Z/t3gGhyMAFnlvgEqiU0jbhu3uzifnZCKImglQM6+VL9O9Vrd6DsDm++HmUcfYmz3x/vcVPSlmo8+URJG/TwPg969SAsGmu+kaBm9eDf/kQbI4voMRkEnF46QyUni2289fGJMWGWYeuyk242rvsmUJrKFuFkSqk2nbPrszrlFkeThvenQelXo6cOSStdd22bdKhKXavR9on6XJqdFinT7rryxmK4SHpjpuLZcPDxsw2m24y2ukmNS0Ym9RkWJPHnar3l5OprOv6OO+Z1qqMxpZV6NYXHvQp7OOfOPvw7eLbNfyZ+bl5F+kKFJu6oBokfTo/lmqSNjE9oPv2YTQq1WGnQYmx6acM1mbKTrhDiZxIz8RTZUy+IMfb5L+6lmfNKw1bUsdwToweQYuBEh429Rg5wUmGDfcVORu1wO+CXFOnUsOYL3kYLBwi//rDXm7ihMcvvhn7hwwpOG82oRGLJF1Fklgb5l8nLhuEdKdTHaTSpBFtcDZyDTtLMFgatZrbEeOcRf6lbBDuztwTbToHivjsOdLXsYErOGx6cF/GRpet+W3Yzn6pLJqbANigjWVV9lgFvuCOfxMc/7hvmvlOGp2Nb69UaWtDrlvpu3PTwIbngsComaU0qXYOG0iPBRmI4Rrt2KDAkaSPx3IM0R6PsomR54+wZelQWOSJoOZ02OIG6ZZlyYsxXsFsYpwNi3u3ZJleD9OnUolBUS/0i30ZvmzAhTqQuqJhFAvEWvTVKlKPMn+7n169efNmY1dFTBdUoFV4APlue9kUR71eZ9wQRA8biHDtXF7CDqIIV0mprQLcQqOlSZWRhTxsyNFBs9ozIN1TQZs0aXszIk3IuvYmiA1sijOsV6rlGTwfK0UNR0K90YZIBLhJkfw1IUgQba7UztBvkvwX2NxpY20FUs68hWyBJN1w2SBk0NnptuJjgzjJao2c3SE/hBpV4E7WpeVlU6M1VISH3odaRPuple7YVuVGrtNaY06hDJHLtKBcc5MgNSa1jtTcKvm1zJksRB1cJ44y7+703mnoui0W/ipOgZPpstHdku9nwyp7qQeYNKEELVPeycwQOe0NyQD3GlV4zpBxat9kV3m027CJlfkvYeM81BFE8iXKTRQTpJRZL1+B7+qqqUhLptp70vpm3t1+OfHofB0qjRZ4TjgNyRo5bLDhlkkfG4vX4izUfElokUTV3I4jbc3Z1JwWF4CW781m7N4EnmFRkKBKFXJcRTAPNNLeQIZko5NvVkz/nY5vocVJHL38c67P694CZsPznfKVXGmorJbisBm5hdLHxvHDq9AASgJYjjP3TAhe42xw1wkYgR4qf282hnsTSEVNkGY0mIkL4p66JOmtIuvAyRFjIS4oeXPGTOL5myF+rPGrRGgfsOVsgUZb2vIGNo5dzNk0A9kMHTazh2CDu+5N7BVsQFDQU61GAQ4CIMvvn3z5+wrIJKio77CWTRoh36owGg0r3YkNmI5j115pWvdlA1fAvNpqDU+5KbrNH9SbPqtT3Z5HWfozqZXtDYa0+PhCB09+JOCVRW9/vQDBW0S+/7oNNo1TfbQotu3DHdho0Ba7MfYjdF82lQLYBuxwC0wuh40bpquMEey0Cm0xuYfIRRxVt/kVJUWtQvvgdd4+EzRnv96fnIKSr0nb8+P9mndpZPVFNFAWDfEubGhL60ReZ+V1bGgxWLkZiYeNBE98xkpAA3nYoD4z2rWBPu/DrSZHLfGi267zVKdIUrw7Y5/Da4p+ue9vuiE9+o91DhVYTFaa9YKsK4SEydk7saHNeb+uQLhjwWP7LbMBtwRZWaW95It7/XBqBgyrkjQZwpibx/Yb221NyQ6p7UfKiGJganSWhJTaM2b08Wh53WDhlBVq/cxvAa+3uvrqftzEpgK58w85UCO3Q2r99mxEHeAQOz3X170+wwo2tIeXi7XCYjCol02L2o+FIlj9vnJD8lqbFWnJZJVuQpuA2szIjcmFixPwsMDIKE7z5SEYskWP3/YqTqybuZdwk1nPhj6huv8Y3K5WvQsbYtthpz3HRX1NnSLNJztNX1xr5Ru/yWO+BQoGD8z1Na15k8jXEJXSHl+Tmn6lS34D6nVRD8vRJ3jl1a378S/C5mfwu3HbNRioXTgIoxHkLjBGMd/CSYSjwAYGHVz7xiJn0lNU3RkWKHrHKKZz+wbzZKp9OBPj3BIbctxtHPJ8LEKvksxTNjO4Ave6+ZgHKEXTwA/WGa6YgwvjodfXhHd6Zq7Y+5yE07d09O9tYMFJG7PcbGm1XDGXmw3MSa5r1F3TqVQdF/uX5GPWmM2cgZLWcDbrslNSzTGkrtAsCY3udEqaHnVmGLbD1jaMLr9PqV7U9UJnca5JGudmxnzMirpMBfL7VrdfAy/KzhlT4soPIZB93PO4A2KTRnSjopsPqawza2fsGwOjJQXeRXj96uLNRzoCCKx28+ZgSQlrD9CUthiz3K5WlyciT+hYMYyJUsMvA7Xq3W7Y7L8uvmfcV1dmjt4mzzIRG1ef/vnJ3amrn68Jq59HERtXyU83v/5H9OsN9b+/3Lx4tq/XW61kMnqrXqRIkSKtk9m8rHt1SZxs89JeOYc+V6pp957KUsZgTcYx3Stka+KAuI7Vtb9Ky3Ts4ImrWvM61sRfLGsteM1gl32tqZ4ljSXFWcPYBc/7yRccmBCM+dmoEOZB3zXVns1qrv8q5nL9KR9BhpGP2OG/0WGDgA2y5tJ7mmAjPhRSwYgGc1CJMCLCh65UC6Pg3XeeiuhEcsv/6tWUxitShQdzUImkrLjDeillu9XGh7QX/ZIom6CNdFrAxhlTKnnZbKfSIHfIy89XsSkb3ZwqtEcNiPgYjxqDkSQOGhD0YU3Jh0pJmEy7RpkUpexgUJcEqZ4rFBueGAqzodPBzDrGMu3wUpUhDLCO7YPagmgVG4gSywppHmgLI3qqwiZ56QfSIvXIH31BkIYYjytNPuw34I2zaCN32BQhCBNWc25kV+CehHuoVWy65FCVTi3zqC9gg5wJWcpGh9gBQepgJMvO8DruUjhaw+304N2KCkXDR9tR4Hsoj/dOnM1EcgWjnYxNdTyDPkwuko7clIozmEjTx7NZvyl62MToUZgMQmweNAUhnqg27Uwh+IRGusAkWaFTLg+6VtDO/ed/7J3OGRtj6Aq2dGZsNFVtwusrWqaqllKq2SY57GfJB9JxedjEUK1cMds2zA9BBEMb5n8MGl4GM31ThU88AwGx3gswii6u4numswtm+3kiI/pth43A+qm8t59ytobzlhurSfOb5RUG/q+xiAFTphNjCjkLb1hTc/HOHVjeE11dLNrFuKhSj4CxAfsm77VvZq0lNq5xKGOklwXNJr+55Nufwd/lVKlMS1yltWYLFlJuEnslp9x4/amZ6ik3FZL1DWzmOzB2aIybMsLIDWZus7naagHDvKBcnNrVACfs5Ou/9kxfT1h706u6qmg+NhvLDUKOx55nbOCQ0++ZhE1HImaQG51tBWxRf5zcOx0zNgvLuO7DRhpgFugrwAQxD3QS272czmO7gjeI3TsF2zfCKjZLbfEim1Ids0BfohSs8WPxTZrZbreaEGFzQG/EWMum5ffD5/5UMBsBordil7TgQMxvDb7mk9MlsxBs/O2h1rIBkwYWRtKcioSHY7qtYWNCUKA1TU+aU3ChGgRLezpgrUxJfzpsVBpKNZz2oY6UoIbI3SEEvK9hI2QtGjkl0+gdiJqBxTm1TtaUKgYYCSGtHv4NrWUDxgrtX2hVqvAPtraWjVCfxy/RCOUsXU4DK07gUONwhnSqNXe5iSvX9mPLjMinIWRIbLAPY3M9G6FVZMHZvPFO9eaw8CEN6FTHSF9kMyWHeI4lGiKqD+jDTsH0AoqR7F2SojCjbHSXTZn87URRSc38qEtXN0HkutA2eHisPnhaGwoqqseWlVRz+zoBvkKszn6XLQ9G+a22+nwm6lB/KuxU7I1Skqm4LuUEXNGorDhSYA2B001nuc8QiUqEcQkeJ62BRfQEXm7wYKpCl2S3JVFqg89gbYg6eFaigxSo37DzdNHQ9KBmXR5brRmLcafx8OPD8RB2oVJr6sxPIaMV9eB+KdURrKiRh09ow/EHEzFyVFU1D+qt9ZEiRXrS+j+scyIK9ca7IAAAAABJRU5ErkJggg==' // Your logo data

    const themeColors = {
      primary: '#488cec',
      primaryText: '#FFFFFF',
      secondary: '#f0f0f0',
      accent: '#f9f9f9',
      border: '#cccccc',
    }

    const docDefinition: TDocumentDefinitions = {
      content: [
        // Header
        {
          unbreakable: true,
          stack: [
            {
              columns: [
                {
                  width: '*',
                  stack: [
                    {
                      image: logoBase64,
                      width: 100,
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: 'Work Order',
                      margin: [0, 0, 0, 10],
                      fontSize: 20,
                      bold: true,
                    },
                  ],
                },
                {
                  width: 250,
                  stack: [
                    {
                      text:
                        'Work Order Number: ' +
                        data.workOrderFields.workOrderId,
                      fontSize: 15,
                      alignment: 'right',
                      bold: true,
                      margin: [0, 0, 0, 10],
                      color: themeColors.primary,
                    },
                    {
                      table: {
                        widths: ['*', '*'],
                        body: [
                          [
                            {
                              text: 'Status',
                              bold: true,
                              fillColor: themeColors.secondary,
                            },
                            {
                              text:
                                data.workOrderFields.status
                                  ? data.workOrderFields.status.charAt(0).toUpperCase() +
                                  data.workOrderFields.status.slice(1)
                                  : 'Ongoing',
                              alignment: 'right',
                            },
                          ],
                          [
                            {
                              text: 'PO #',
                              bold: true,
                              fillColor: themeColors.secondary,
                            },
                            {
                              text:
                                data.workOrderFields.purchaseOrderNumber || masterCommonService.getClientName(
                                  data.workOrderFields.workOrderCompanyId,
                                )?.companyName || '-',
                              alignment: 'right',
                            },
                          ],
                          [
                            {
                              text: 'Date',
                              bold: true,
                              fillColor: themeColors.secondary,
                            },
                            {
                              text:
                                datePipe.transform(
                                  data.workOrderFields.workOrderDate,
                                  'dd/MM/yyyy',
                                ) || '-',
                              alignment: 'right',
                            },
                          ],
                        ],
                      },
                      layout: 'noBorders',
                      margin: [0, 10, 0, 0],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          stack: [
            {
              text: 'Remarks',
              fontSize: 13,
              bold: true,
              margin: [0, 0, 0, 6],
              color: themeColors.primary,
            },
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text:
                        data.workOrderFields.remarks || 'No remarks provided.',
                      fillColor: themeColors.accent,
                      margin: [5, 5, 5, 5],
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: themeColors.border,
                vLineColor: themeColors.border,
              },
            },
          ],
          unbreakable: true, // ✅ put here
        },
        // Items Table
        {
          unbreakable: false,
          stack: [
            {
              table: {
                headerRows: 1,
                widths: ['auto', 250, 70, 70, 70],
                body: [
                  [
                    {
                      text: 'Sr No',
                      bold: true,
                      fillColor: themeColors.primary,
                      color: themeColors.primaryText,
                      alignment: 'center',
                    },
                    {
                      text: 'Description',
                      bold: true,
                      fillColor: themeColors.primary,
                      color: themeColors.primaryText,
                      alignment: 'center',
                      noWrap: true,
                    },
                    {
                      text: 'Ordered Quantity',
                      bold: true,
                      fillColor: themeColors.primary,
                      color: themeColors.primaryText,
                      alignment: 'center',
                    },
                    {
                      text: 'Pending Quantity',
                      bold: true,
                      fillColor: themeColors.primary,
                      color: themeColors.primaryText,
                      alignment: 'center',
                    },
                    {
                      text: 'Unit',
                      bold: true,
                      fillColor: themeColors.primary,
                      color: themeColors.primaryText,
                      alignment: 'center',
                    },
                  ],
                  ...data.workOrderItems.map((item, index) => [
                    {
                      text: item.srNo,
                      fillColor: index % 2 === 0 ? '#fff' : themeColors.accent,
                      alignment: 'center',
                    },
                    {
                      text: [
                        item.partNumberId &&
                          masterCommonService.getPartNumberName(
                            item.partNumberId,
                          )?.partName
                          ? masterCommonService.getPartNumberName(
                            item.partNumberId,
                          )?.partName
                          : '',
                        item.description || '',
                      ]
                        .filter(Boolean)
                        .join('\n'),
                      fillColor: index % 2 === 0 ? '#fff' : themeColors.accent,
                    },
                    {
                      text: item.quantity.toFixed(2),
                      fillColor: index % 2 === 0 ? '#fff' : themeColors.accent,
                      alignment: 'right',
                    },
                    {
                      text: (
                        (item.quantity || 0) - (item.dispatchedQuantity || 0)
                      ).toFixed(2),
                      fillColor: index % 2 === 0 ? '#fff' : themeColors.accent,
                      alignment: 'right',
                    },
                    {
                      text: masterCommonService.getUnitName(item.unit)?.unitName || '-',
                      fillColor: index % 2 === 0 ? '#fff' : themeColors.accent,
                      alignment: 'center',
                    },
                  ]),
                ],
              },
              margin: [0, 20, 0, 20],
              layout: {
                hLineWidth: (i: any, node: any) =>
                  i === 0 || i === node.table.body.length ? 1 : 0.5,
                vLineWidth: () => 0.5,
                hLineColor: themeColors.border,
                vLineColor: themeColors.border,
              },
            },
          ],
        },
        {
          stack: [
            {
              text: `Created By: ${data.workOrderFields.addedBy || '-'}`,
              alignment: 'right',
              margin: [0, 30, 0, 0],
              fontSize: 10,
              color: '#555',
            },
            {
              text: `Updated By: ${data.workOrderFields.modifiedBy || '-'}`,
              alignment: 'right',
              margin: [0, 10, 0, 0],
              fontSize: 10,
              color: '#555',
            },
          ],
          unbreakable: true,
        },
      ],

      defaultStyle: {
        fontSize: 11,
      },
      pageMargins: [40, 40, 40, 60],
      footer: function (currentPage: number, pageCount: number) {
        return {
          columns: [
            { text: '' },
            {
              text: `Page ${currentPage} of ${pageCount}`,
              alignment: 'right',
              fontSize: 9,
              margin: [0, 0, 40, 0],
              color: '#888888',
            },
          ],
        }
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }
}
